export enum MessagesTypes {
    AVISO = "AVISOFEEDBACK"
}